
import React from 'react'
export const logo = <img className="nav-panel-logo" width={240} src={require('../svg/logoclinica.png')} />
export const primsaImage = <img src={require('../svg/Prisma16.png')} />
export const colorNavBar = layout => '#fff';
export const logoHome = <img className="home-logo" src={require('../svg/logohome.png')} />